import { useTranslation } from 'react-i18next';

import { Formation } from 'components/types';

import { displayNumber, displayPercentage } from 'utils/misc';

import { TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

import { NumericTableCell } from 'components/shared/Table';

type Props = {
  formation: Formation;
  rowName: string;
};

const NetTableRow = styled(TableRow)(() => ({
  height: '60px'
}));

const NetFormationTableRow = ({ formation, rowName }: Props) => {
  const { periodHours, totalYearHours, formationPercentage } = formation;
  const { t } = useTranslation('common');

  return (
    <NetTableRow>
      <TableCell colSpan={3} />
      <TableCell colSpan={4}>{t(`formationTypes.${rowName}`)}</TableCell>
      {periodHours.map(({ number, hours }) => (
        <NumericTableCell key={`${rowName}_${number}`}>
          {displayNumber(Math.round(hours))}
        </NumericTableCell>
      ))}
      <NumericTableCell width={68}>
        {displayNumber(Math.round(totalYearHours))}
      </NumericTableCell>
      <NumericTableCell width={68}>
        {displayPercentage(formationPercentage)}
      </NumericTableCell>
    </NetTableRow>
  );
};

export default NetFormationTableRow;
